const light = ({ lightColorPalette }) => lightColorPalette[0];

export default light;
